import Http from './../http';

const prefix = '/mirror';

export const get = () => {
  return Http.authApi().get(`${prefix}/get`);
};

export const updateCache = (id) => {
  return Http.authApi().get(`${prefix}/updateCache/${id}`);
};

export const deleteMirror = (id) => {
  return Http.authApi().get(`${prefix}/delete/${id}`);
};

export const connect = (params) => {
  return Http.authApi().post(`${prefix}/store`, params);
};



// WEBPACK FOOTER //
// ./src/js/services/editor/mirror.js